<template>
  <!-- 标题 -->
  <ItemTitle type="jingxuan" class="physical-home-downtick-list-container">
    <template v-slot:header>
      <img src="../imgs/home_jingxuan_logo.png" alt="">
      <p>9.9精选</p>
    </template>
    <!-- 内容 -->
    <div v-loading="isLoading">
      <md-scroll-view
        ref="jingPinScrollView"
        :scrolling-y="false"
        :touch-angle="80"
        :is-prevent="false"
      >
        <ul class="list">
          <DowntickItem v-for="(item, index) in listData" :key="index" :item="item"/>
        </ul>
      </md-scroll-view>
    </div>
  </ItemTitle>
</template>

<script>
import { getYouZanKeGoods } from '@/api/distribution'
import { ScrollView } from 'mand-mobile'
import ItemTitle from "./itemTitle"
import DowntickItem from "./downTickItem"
export default {
  data() {
    return {
      isLoading: false,
      listData: []
    }
  },
  methods: {
    load() {
      this.isLoading = true;
      let params = {
        pageNum: 1,
        pageSize: 6,
        categoryId: '',
        titleLike: '',
        orderBy: '',
        orderFlag: '',
        source: '',
        directionalFlag: false,
        minPrice: '',
        maxPrice: '',
        minCommissionRate: '',
        maxCommissionRate: '',
        label: 1
      }
      getYouZanKeGoods(params).then(res=>{
        if(res.success) {
          this.listData = res.data.goodList || [];
          this.$refs.jingPinScrollView.reflowScroller()
          this.isLoading = false;
        }
      })
    }
  }, 
  components: {
    ItemTitle,
    DowntickItem
  },
  created() {
    this.load()
  }
}
</script>

<style lang="scss">
.physical-home-downtick-list-container {
  .list {
    display: flex;
  }
}
</style>